const filterOptionsJobPosts = [
    {
      name: 'format',
      label: 'Establecimiento',
      options: [
        'Restaurante', 
        'Bar', 'Pub', 'Cafeteria', 'Heladeria', 'Empresa', 'Banquetera', 'Restobar', 'Dark Kitchen', 'Fastfood', 'Pasteleria', 'Foodtruck', 'Hotel', 'Panaderia', 'Casino'],
    },
    {
      name: 'region',
      label: 'Regiones',
      options: [
        "Arica y Parinacota", "Tarapacá", "Antofagasta", "Atacama", "Coquimbo",
        "Valparaíso", "O'Higgins", "Maule", "Ñuble", "Biobío", "La Araucanía",
        "Los Ríos", "Los Lagos", "Aysén", "Magallanes", "Metropolitana"
      ],
    },
    {
      name: 'comuna',
      label: 'Comuna',
      options: [
        "Santiago", "Puente Alto", "Maipú", "Las Condes", "La Florida", "Ñuñoa",
        "Vitacura", "Macul", "San Miguel", "Recoleta", "Providencia", "Quilicura",
        "La Pintana", "Pudahuel", "Estación Central", "Pedro Aguirre Cerda"
      ],
    },
    {
      name: 'specialty',
      label: 'Especialidad',
      options: ['Comida Mediterránea', 'Comida Internacional','Comida India', 'Comida China', 'Comida Americana', 'Comida Vegetariana', 'Comida Francesa', 'Comida Arabe', 'Comida Peruana', 'Comida Criolla', 'Comida Italiana', 'Comida Cubana', 'Comida Española', 'Comida Colombiana', 'Comida Tradicional', 'Comida Japonesa', 'Parrillada', "Pescados y Mariscos", "Sanguchería", "Wine Bar", "Cafetería", "Hamburguesería" ],
    },
    {
      name: 'position',
      label: 'Posiciones',
      options: [
        'Garzón', 'Runner', 'Chef', 'Ayudante de Cocina', 'Anfitrión', 'Delivery', 'Cajero', 'Copero',
        'Barista', 'Bartender', 'Sommelier', 'Maitre', 'Jefe de salón', 'Limpieza', 'Chef Ejecutivo',
        'Sous Chef', 'Jefe de Cocina', 'Maestro de Cocina', 'Maestro Pastelero', 'Pastelero', 'Panadero',
        'Repostero', 'Charcutero', 'Pizzero', 'Itamae', 'Sushiman', 'Ayudante de Sushi', 'Parrillero',
        'Cocinero Frío', 'Cocinero Caliente', 'Manipulador de Alimentos', 'Encargado de Producción',
        'Operador de Cocina', 'Operador de Planta', 'Operador Multifuncional', 'Encargado de Reservas',
        'Recepcionista de Restaurante', 'Supervisor de Salón', 'Personal de Banquetería', 'Encargado de Bodega',
        'Repositor', 'Personal de Mantenimiento', 'Jefe de Local', 'Administrador de Local', 'Jefe de Sucursales',
        'Administrador de Restaurante', 'Encargado de Compras', 'Control de Calidad', 'Catador de Vinos',
        'Coordinador de Banquetes', 'Montajista', 'Mixólogo'
      ],
    },
    {
      name: 'benefits',
      label: 'Beneficios',
      options: ['Seguro', 'Traslado', 'Uniforme', 'Capacitaciones', 'Colación', 'Formación','Cumpleaños libre', 'Convenios externos','Descuentos corporativos', 'Contratos corporativos', 'Otros'],
    },
    {
      name: 'contract',
      label: 'Contrato',
      options: ['A plazo', 'Indefinido', 'Honorarios', 'Práctica']
    },
    {
      name: 'period',
      label: 'Periodo',
      options: ['Permanente', 'Reemplazo Temporal', 'Reemplazo Urgente']
    },
    {
      name: 'schedule',
      label: 'Jornada',
      options: ['Tiempo completo', 'Tiempo parcial']
    }
];

const filterOptionsCompany = [
    {
      name: 'format',
      label: 'Establecimiento',
      options: ['Restaurante', 'Bar', 'Pub', 'Cafeteria', 'Heladeria', 'Empresa', 'Banquetera', 'Restobar', 'Dark Kitchen', 'Fastfood', 'Pasteleria', 'Foodtruck', 'Hotel', 'Panaderia', 'Casino'],
    },
    {
      name: 'region',
      label: 'Regiones',
      options: [
        "Arica y Parinacota", "Tarapacá", "Antofagasta", "Atacama", "Coquimbo",
        "Valparaíso", "O'Higgins", "Maule", "Ñuble", "Biobío", "La Araucanía",
        "Los Ríos", "Los Lagos", "Aysén", "Magallanes", "Metropolitana"
      ],
    },
    {
      name: 'comuna',
      label: 'Comuna',
      options: [
        "Santiago", "Puente Alto", "Maipú", "Las Condes", "La Florida", "Ñuñoa",
        "Vitacura", "Macul", "San Miguel", "Recoleta", "Providencia", "Quilicura",
        "La Pintana", "Pudahuel", "Estación Central", "Pedro Aguirre Cerda"
      ],
    },
    {
      name: 'specialty',
      label: 'Especialidad',
      options: ['Comida Mediterránea', 'Comida Internacional','Comida India', 'Comida China', 'Comida Americana', 'Comida Vegetariana', 'Comida Francesa', 'Comida Arabe', 'Comida Peruana', 'Comida Criolla', 'Comida Italiana', 'Comida Cubana', 'Comida Española', 'Comida Colombiana', 'Comida Tradicional', 'Comida Japonesa', 'Parrillada', "Pescados y Mariscos", "Sanguchería", "Wine Bar", "Coffee Shop", "Burger Joint"],
    },
    {
      name: 'benefits',
      label: 'Beneficios',
      options: ['Seguro', 'Traslado', 'Uniforme', 'Capacitaciones', 'Colación', 'Formación','Cumpleaños libre', 'Convenios externos','Descuentos corporativos', 'Contratos corporativos', 'Otros'],
    },
    {
      name: 'position',
      label: 'Posiciones',
      options: [
        'Garzón', 'Runner', 'Chef', 'Ayudante de Cocina', 'Anfitrión', 'Delivery', 'Cajero', 'Copero',
        'Barista', 'Bartender', 'Sommelier', 'Maitre', 'Jefe de salón', 'Limpieza', 'Chef Ejecutivo',
        'Sous Chef', 'Jefe de Cocina', 'Maestro de Cocina', 'Maestro Pastelero', 'Pastelero', 'Panadero',
        'Repostero', 'Charcutero', 'Pizzero', 'Itamae', 'Sushiman', 'Ayudante de Sushi', 'Parrillero',
        'Cocinero Frío', 'Cocinero Caliente', 'Manipulador de Alimentos', 'Encargado de Producción',
        'Operador de Cocina', 'Operador de Planta', 'Operador Multifuncional', 'Encargado de Reservas',
        'Recepcionista de Restaurante', 'Supervisor de Salón', 'Personal de Banquetería', 'Encargado de Bodega',
        'Repositor', 'Personal de Mantenimiento', 'Jefe de Local', 'Administrador de Local', 'Jefe de Sucursales',
        'Administrador de Restaurante', 'Encargado de Compras', 'Control de Calidad', 'Catador de Vinos',
        'Coordinador de Banquetes', 'Montajista', 'Mixólogo'
      ],
    },
    {
      name: 'workers',
      label: 'Trabajadores',
      options: ['0-50', '50-100', '100-200', '200-300', '300-400', '+400'],
    },
    {
      name: 'weeklyAverageClients',
      label: 'Clientes semanales',
      options: ['0-50', '50-100', '100-200', '200-300', '300-400', '+400'],
    },
  ];

export  {filterOptionsJobPosts, filterOptionsCompany};
